import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import Plx from "react-plx";
import { Container, Grid, Typography } from "@material-ui/core";

import useWindowDimensions from "../../../common/hooks/useWindowDimensions";

import { styles, plantAnim, podsAnim, stemAnim } from "./StemPods.styles";

function StemPods({ classes, screen }) {
  const { height: viewHeight } = useWindowDimensions();
  return (
    <Container maxWidth="md" className={classes.root}>
      <Grid container>
        <Grid item xs={4}>
          <Plx
            className={classes.stemPlx}
            parallaxData={stemAnim({ viewHeight, screen })}
          >
            <Typography variant="h3" component="h2" className={classes.title}>
              STEM
            </Typography>
            <br />
            <Typography component="p" className={classes.description}>
              O STEM é o centro de operações, composto por um raspberryPi e um
              arduino, comunica usando HC12 ou USB com os Pods.
            </Typography>
            <Typography component="p" className={classes.description}>
              Contem sensores de temperatura e humidade para garantir que está
              em bom funcionamento
            </Typography>
            <Typography component="p" className={classes.description}>
              O STEM necessita de estar ligado a uma rede com internet para
              permitir acesso ao sistema remotamente
            </Typography>
          </Plx>
        </Grid>
        <Grid item xs={4} className={classes.plantBox}>
          <Plx
            className={classes.plantPlx}
            parallaxData={plantAnim({ viewHeight, screen })}
          >
            <img src="./plant.svg" className={classes.plant} alt="alt" />
          </Plx>
        </Grid>
        <Grid item xs={4}>
          <Plx
            className={classes.podsPlx}
            parallaxData={podsAnim({ viewHeight, screen })}
          >
            <Typography variant="h3" component="h2" className={classes.title}>
              PODS
            </Typography>
            <br />
            <Typography component="p" className={classes.description}>
              Os PODS, sao pontos elementos modulares que comunicam com o STEM
              via USB ou HC12
            </Typography>
            <Typography component="p" className={classes.description}>
              Os PODS podem ser completamente "wireless" com um suporte de
              bateria e/ou painel solar
            </Typography>
            <Typography component="p" className={classes.description}>
              PODS:
            </Typography>
            <ul>
              <li className={classes.description}>
                Monitorização temperatura e humidade
              </li>
              <li className={classes.description}>
                Controlo de relés - permite ligar/desligar qualquer aparelho
                220v
              </li>
              <li className={classes.description}>
                Necessidades especificas do cliente
              </li>
            </ul>
          </Plx>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withStyles(styles)(StemPods);
